import api from '../services/api';

const notificationAPI = {
  // Get user notifications
  getNotifications: async (params = {}) => {
    const response = await api.get('/notifications', { params });
    return response.data;
  },

  // Get unread count
  getUnreadCount: async () => {
    const response = await api.get('/notifications/unread/count');
    return response.data;
  },

  // Mark as read
  markAsRead: async (notificationId) => {
    const response = await api.put(`/notifications/${notificationId}/read`);
    return response.data;
  },

  // Mark all as read
  markAllAsRead: async () => {
    const response = await api.put('/notifications/read-all');
    return response.data;
  },

  // Delete notification
  deleteNotification: async (notificationId) => {
    const response = await api.delete(`/notifications/${notificationId}`);
    return response.data;
  },

  // Get preferences
  getPreferences: async () => {
    const response = await api.get('/notifications/preferences');
    return response.data;
  },

  // Update preferences
  updatePreferences: async (preferences) => {
    const response = await api.put('/notifications/preferences', preferences);
    return response.data;
  },

  // Test notification
  sendTest: async (data) => {
    const response = await api.post('/notifications/test', data);
    return response.data;
  },

  // ===== ALERTS =====

  // Get alerts
  getAlerts: async (params = {}) => {
    const response = await api.get('/notifications/alerts', { params });
    return response.data;
  },

  // Get single alert
  getAlert: async (alertId) => {
    const response = await api.get(`/notifications/alerts/${alertId}`);
    return response.data;
  },

  // Create alert
  createAlert: async (alertData) => {
    const response = await api.post('/notifications/alerts', alertData);
    return response.data;
  },

  // Update alert
  updateAlert: async (alertId, updates) => {
    const response = await api.put(`/notifications/alerts/${alertId}`, updates);
    return response.data;
  },

  // Delete alert
  deleteAlert: async (alertId) => {
    const response = await api.delete(`/notifications/alerts/${alertId}`);
    return response.data;
  },

  // Test alert
  testAlert: async (alertId) => {
    const response = await api.post(`/notifications/alerts/${alertId}/test`);
    return response.data;
  },

  // Check alert
  checkAlert: async (alertId) => {
    const response = await api.post(`/notifications/alerts/${alertId}/check`);
    return response.data;
  },

  // Get alert stats
  getAlertStats: async () => {
    const response = await api.get('/notifications/alerts/stats/summary');
    return response.data;
  },

  // ===== OI ALERT DISPATCH =====

  // Submit classified OI escalations for server-side notification delivery
  postOIDigest: async ({ escalations }) => {
    const response = await api.post('/notifications/alerts/oi-digest', { escalations });
    return response.data;
  }
};

export default notificationAPI;
